import * as SentryBrowser from '@sentry/react';
import { ENVIRONMENT } from '@/config/settings';

export class Sentry {
  init() {
    SentryBrowser.init({
      dsn: 'https://fbbca01316404b85adbe176420d62db7@sentry.io/183620',
      environment: ENVIRONMENT,
      debug: ENVIRONMENT === 'development'
    });
  }
  identify(user) {
    SentryBrowser.setUser({
      id: user.userId
    });
  }
  trackError(error, extra, severity) {
    SentryBrowser.withScope(scope => {
      scope.setLevel(severity);
      for (let detail in extra) {
        scope.setExtra(detail, extra[detail]);
      }
      SentryBrowser.captureException(error);
    });
  }
}
